import { render } from "./DynamicRenderer.vue?vue&type=template&id=6e1aeef5&scoped=true"
import script from "./DynamicRenderer.vue?vue&type=script&lang=js"
export * from "./DynamicRenderer.vue?vue&type=script&lang=js"

import "./DynamicRenderer.vue?vue&type=style&index=0&id=6e1aeef5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1aeef5"]])

export default __exports__